<aside
  class="sidebar bg-dark text-white shadow"
  [class.collapsed]="layoutService.isSidebarCollapsed()"
  [class.mobile-open]="layoutService.isMobileMenuOpen()"
>
  <!-- 1. Header Sidebar -->
  <div
    class="sidebar-header d-flex align-items-center px-3 py-3 border-bottom border-secondary"
  >
    <div class="logo-area d-flex align-items-center gap-3">
      <img src="images/logo24x24.png" class="icon-md" alt="4SGEN Logo" />
      @if (!layoutService.isSidebarCollapsed()) {
        <span class="logo-text fw-bold fs-5"> 4SGEN Admin </span>
      }
    </div>

    <!-- Nút đóng trên mobile -->
    <button
      class="btn text-white d-lg-none ms-auto shadow-none p-0"
      (click)="layoutService.toggleSidebar()"
      [attr.aria-label]="'COMMON.CLOSE' | translate"
    >
      <svg lucideX class="icon-md"></svg>
    </button>
  </div>

  <!-- 2. Menu Navigation (Scrollable) -->
  <nav class="sidebar-nav py-3 px-2 flex-grow-1 overflow-auto scroll-thin-dark">
    @for (item of menuTree(); track item.id) {
      @if (item.is_read > 0) {
        <div class="menu-item-group mb-1">
          <!-- 2.1 TRƯỜNG HỢP: NHÃN NHÓM (Không có path và icon) -->
          @if (!item.icon && !item.path) {
            @if (!layoutService.isSidebarCollapsed()) {
              <div
                class="menu-group-label text-uppercase text-secondary fw-semibold px-3 mb-2 mt-3"
              >
                {{ item.name | translate }}
              </div>
            }
          }

          <!-- 2.2 TRƯỜNG HỢP: MENU ITEM (Có link hoặc có con) -->
          @else {
            <a
              class="menu-item d-flex align-items-center px-3 py-2 rounded-2 text-decoration-none"
              [class.active]="isActive(item)"
              [routerLink]="
                item.children && item.children.length > 0
                  ? null
                  : item.path || null
              "
              (click)="
                item.children && item.children.length > 0
                  ? toggleSubMenu(item)
                  : layoutService.isMobile() && layoutService.toggleSidebar()
              "
              tabindex="0"
              role="button"
            >
              <div class="menu-icon-wrapper">
                @if (item.icon) {
                  <app-dynamic-icon [name]="item.icon" cssClass="icon-sm" />
                } @else {
                  <!-- Placeholder icon cho item không có icon để khi thu nhỏ vẫn thấy điểm nhấn -->
                  <div
                    class="icon-sm d-flex align-items-center justify-content-center"
                  >
                    <div
                      class="width-5 height-5 bg-white opacity-25 rounded-circle"
                    ></div>
                  </div>
                }
              </div>

              @if (!layoutService.isSidebarCollapsed()) {
                <span class="menu-text flex-grow-1 ms-3">
                  {{ item.name | translate }}
                </span>
                @if (item.children && item.children.length > 0) {
                  <svg
                    lucideChevronRight
                    class="ms-auto icon-xs transition-300"
                    [class.rotate-90]="isExpanded(item.id)"
                  ></svg>
                }
              }
            </a>
          }

          <!-- 2.3 RENDER CHỈ MỤC CON (SUB-MENU) -->
          @if (
            item.children &&
            item.children.length > 0 &&
            isExpanded(item.id) &&
            !layoutService.isSidebarCollapsed()
          ) {
            <div
              class="sub-menu sub-menu-open ms-4 ps-2 mt-1 border-start border-secondary"
            >
              @for (child of item.children; track child.id) {
                @if (child.is_read > 0) {
                  <a
                    class="sub-menu-item d-flex align-items-center px-3 py-1 rounded text-secondary text-decoration-none mb-1"
                    [routerLink]="child.path"
                    routerLinkActive="active-sub"
                    (click)="
                      layoutService.isMobile() && layoutService.toggleSidebar()
                    "
                  >
                    @if (child.icon) {
                      <app-dynamic-icon
                        [name]="child.icon"
                        cssClass="icon-xs me-2"
                      />
                    }
                    <span>{{ child.name | translate }}</span>
                  </a>
                }
              }
            </div>
          }
        </div>
      }
    }
  </nav>
</aside>

<!-- Backdrop fix A11y -->
@if (layoutService.isMobileMenuOpen() && layoutService.isMobile()) {
  <div
    class="mobile-backdrop position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-50 z-3"
    (click)="layoutService.toggleSidebar()"
    (keydown.enter)="layoutService.toggleSidebar()"
    role="button"
    tabindex="0"
    [attr.aria-label]="'COMMON.TOGGLE_MENU' | translate"
  ></div>
}
